import { BaseIcon } from './base';
import type { IconProps } from './base';

export function IconCareer(props: IconProps) {
  return (
    <BaseIcon {...props}>
      <path
        fillRule="evenodd"
        d="m8.698 12-4.466 5.36A1 1 0 0 0 5 19h10a1 1 0 0 0 .768-.36l5-6a1 1 0 0 0 0-1.28l-5-6A1 1 0 0 0 15 5H5a1 1 0 0 0-.768 1.64L8.698 12Zm1.537-1.28a2 2 0 0 1 0 2.56L7.135 17h7.397l4.166-5-4.166-5H7.135l3.1 3.72Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
